import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import ProductEditList from '../components/admin/ProductEditList';
import GenerateAllDescriptions from '../components/admin/GenerateAllDescriptions';
import BannerManager from '../components/admin/BannerManager';
import './AdminPage.css';

const AdminPage = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('produtos');
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleMenuToggle = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleSectionChange = (section) => {
    setActiveSection(section);
    if (window.innerWidth <= 992) {
      setMobileMenuOpen(false); // Fecha o menu ao selecionar no celular
    }
  };

  // Fecha o menu se a janela for redimensionada para uma tela maior
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 992) {
        setMobileMenuOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <div className={`overlay ${isMobileMenuOpen ? 'show' : ''}`} onClick={handleMenuToggle}></div>
      <div className="admin-container">
        <button className="mobile-menu-toggle" onClick={handleMenuToggle}>
          <i className={`fas ${isMobileMenuOpen ? 'fa-times' : 'fa-bars'}`}></i>
        </button>

        <div className={`admin-sidebar ${isMobileMenuOpen ? 'open' : ''}`}>
          <div className="sidebar-header">
            <img src="/logo/LOGO.png" alt="Floratta" className="admin-logo" />
            <h3>Floratta Cosméticos</h3>
          </div>
          
          <nav className="sidebar-nav">
            <ul>
              <li className={activeSection === 'dashboard' ? 'active' : ''}>
                <button onClick={() => handleSectionChange('dashboard')}>
                  <i className="fas fa-tachometer-alt"></i> <span>Dashboard</span>
                </button>
              </li>
              <li className={activeSection === 'produtos' ? 'active' : ''}>
                <button onClick={() => handleSectionChange('produtos')}>
                  <i className="fas fa-box"></i> <span>Produtos</span>
                </button>
              </li>
              <li className={activeSection === 'categorias' ? 'active' : ''}>
                <button onClick={() => handleSectionChange('categorias')}>
                  <i className="fas fa-tags"></i> <span>Categorias</span>
                </button>
              </li>
              <li className={activeSection === 'gerar-descricoes' ? 'active' : ''}>
                <button onClick={() => handleSectionChange('gerar-descricoes')}>
                  <i className="fas fa-robot"></i> <span>Gerar Descrições</span>
                </button>
              </li>
              <li className={activeSection === 'banners' ? 'active' : ''}>
                <button onClick={() => handleSectionChange('banners')}>
                  <i className="fas fa-images"></i> <span>Gerenciar Banners</span>
                </button>
              </li>
              <li className={activeSection === 'configuracoes' ? 'active' : ''}>
                <button onClick={() => handleSectionChange('configuracoes')}>
                  <i className="fas fa-cog"></i> <span>Configurações</span>
                </button>
              </li>
            </ul>
            
            <div className="user-info">
              <span>Olá, {user?.username || 'Administrador'}</span>
              <button onClick={handleLogout} className="logout-button">
                <i className="fas fa-sign-out-alt"></i> <span>Sair</span>
              </button>
            </div>
          </nav>
        </div>
        
        <div className="admin-content">
          <div className="admin-main-content">
            {activeSection === 'dashboard' && (
              <div className="dashboard-container">
                <h2>Bem-vindo ao Painel Administrativo</h2>
                <p>Selecione uma opção no menu lateral para começar.</p>
                
                <div className="dashboard-stats">
                  <div className="stat-card">
                    <div className="stat-icon"><i className="fas fa-box"></i></div>
                    <div className="stat-info">
                      <h3>Produtos</h3>
                      <p className="stat-value">150</p>
                    </div>
                  </div>
                  
                  <div className="stat-card">
                    <div className="stat-icon"><i className="fas fa-tags"></i></div>
                    <div className="stat-info">
                      <h3>Categorias</h3>
                      <p className="stat-value">12</p>
                    </div>
                  </div>
                  
                  <div className="stat-card">
                    <div className="stat-icon"><i className="fas fa-sync"></i></div>
                    <div className="stat-info">
                      <h3>Última Sincronização</h3>
                      <p className="stat-value">Hoje às 10:30</p>
                    </div>
                  </div>
                </div>
              </div>
            )}
            
            {activeSection === 'produtos' && <ProductEditList />}
            
            {activeSection === 'gerar-descricoes' && <GenerateAllDescriptions />}
            
            {activeSection === 'banners' && <BannerManager />}
            
            {activeSection === 'categorias' && (
              <div className="categories-container">
                <h2>Gerenciamento de Categorias</h2>
                <p>Funcionalidade em desenvolvimento.</p>
              </div>
            )}
            
            {activeSection === 'configuracoes' && (
              <div className="settings-container">
                <h2>Configurações</h2>
                <div className="settings-section">
                  <h3>Sincronização</h3>
                  <div className="setting-item">
                    <label>Intervalo de sincronização automática:</label>
                    <select defaultValue="15">
                      <option value="5">5 minutos</option>
                      <option value="15">15 minutos</option>
                      <option value="30">30 minutos</option>
                      <option value="60">1 hora</option>
                    </select>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminPage;
